<template>
	<el-dialog v-model="showDialog" class="choose-person-dialog" :width="900" :close-on-click-modal="false" @close="handleClose">
		<template #header>
			<div class="dialog_title">
				<span class="title">人员</span>
				<div class="search">
					<el-popover placement="bottom" :width="500" :visible="triggerVis" :visible-arrow="false" popper-class="person_search_popper">
						<template #reference>
							<el-input
								:disabled="inputDisabled"
								@focus="
									triggerVis = true;
									triggerFocus = true;
								"
								@blur="triggerFocus = false"
								v-model="personParam.keyWord"
								placeholder="搜索工号、拼音、姓名、手机号"
								size="small"
								@input="searchPersonList"
							>
								<template #prefix>
									<i class="el-input__icon el-icon-search"></i>
								</template>
							</el-input>
						</template>
						<div v-click-outside="onClickOutside">
							<div v-loading="searchLoading" element-loading-text="加载中" class="no_data" v-show="searchList.length == 0">
								<img class="delete_img" src="./img/ico_empty.png" />
								<div>暂无结果，请重新输入</div>
							</div>
							<div v-loading="searchLoading" element-loading-text="加载中" v-if="searchList.length > 0">
								<person-item v-for="(item, key) in searchList" :key="`${item.id}${item.personCode}${key}`" :item="item"
								:index="key" tag="search" :multiple="multiple"
								:disabled="multiDeptsFlag ? disabledList.indexOf(item.personCode + '#' + item.departCode) > -1 : disabledList.indexOf(item.personCode) > -1"
								:checked="multiple ? item.checked : checked" :multi-depts-flag="multiDeptsFlag"
								@change="({ item, checked, operate, index }) => personItemChange(item, checked, operate, index)">
							</person-item>
							</div>
						</div>
					</el-popover>
				</div>
				<span></span>
			</div>
		</template>
		<div class="content">
			<div id="left">
				<div class="tab">
					<div class="tab_content column">
						<div class="column-left">
							<!-- max-width 树的宽度 -->
							<div class="resize-bar"></div>
							<div class="resize-line"></div>
							<div class="resize-save">
								<div class="el-tree-wrap" v-loading="treeLoading" element-loading-text="加载中">
									<div class="dept_search">
										<el-input v-model="searchDept" placeholder="输入部门搜索" size="small">
											<template #prefix><i class="el-input__icon el-icon-search"></i></template>
										</el-input>
									</div>
									<el-tree
										ref="treeRef"
										node-key="id"
										empty-text=""
										highlight-current
										:data="deptList"
										:props="defaultProps"
										:default-expanded-keys="defaultExpandedKeysDept"
										:expand-on-click-node="false"
										@node-click="handleNodeClick"
										:filter-node-method="filterNode"
									></el-tree>
									<div class="no_data" v-show="deptListEmpty">
										<img class="delete_img" src="./img/ico_empty.png" />
										<div>暂无结果，请重新输入</div>
									</div>
								</div>
							</div>
						</div>
						<div class="middle column-right" id="middle" v-loading="loading" element-loading-text="加载中">
							<div class="person_wrap">
								<template v-if="personList.length > 0">
									<div class="person_all" v-if="multiple">
										<el-checkbox v-model="checkedAll" :disabled="disabledCheckAll()" @change="chooseAll"></el-checkbox>
										<span>全选</span>
									</div>
									<person-item v-for="(item, key) in personList" :key="`${item.id}${key}`" :item="item" :index="key"
										:multiple="multiple"
										:disabled="multiDeptsFlag ? disabledList.indexOf(item.personCode + '#' + item.departCode) > -1 : disabledList.indexOf(item.personCode) > -1"
										:checked="multiple ? item.checked : checked" :multi-depts-flag="multiDeptsFlag"
										@change="({ item, checked, operate, index }) => personItemChange(item, checked, operate, index)">
									</person-item>
								</template>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div class="choose" id="right" v-loading="chooseLoading" element-loading-text="加载中">
				<div class="amount">
					<div>
						已选择
						<span v-if="multiple">（{{ chooseList.length }}）</span>
					</div>
					<div v-if="disabledList.length==0"  class="clear" @click="clearChoose">清空</div>
				</div>
				<div class="choose_data">
					<person-item v-for="(item, key) in chooseList" :key="key" :item="item" :index="key" tag="choose"
						:is-delete-show="multiDeptsFlag ? disabledList.indexOf(item['personCode'] + '#' + item['departCode']) == -1 : disabledList.indexOf(item.personCode) == -1"
						@delete="deleteChoose(item)">
					</person-item>
				</div>
				<div class="dialog-footer border-top">
					<el-button size="small" @click="handleClose">取消</el-button>
					<el-button :disabled="disabledConfirm? chooseList.length == 0: false" size="small" type="primary" :loading="confirmLoading" @click="handleConfirm">确定</el-button>
				</div>
			</div>
		</div>
	</el-dialog>
</template>

<script setup lang="ts">
import { ref, reactive, toRefs, watch, computed } from "vue";
import { ElMessage,ClickOutside as vClickOutside  } from "element-plus";
import  userCenterApi  from "../../../service/usercenter";
import personItem from "./components/person-item.vue";
defineOptions({
  name: "TqPersonSelectorSaas",
});
const props = defineProps({
	multiDeptsFlag: { type: Boolean, default: false },
	auth: { type: Boolean, default: false },
	visible: { type: Boolean, required: true },
	tenantId: { type: String, required: false },
	departCode: { type: String, default: "" },
	list: {
		type: Array,
		default() {
			return [];
		},
	},
	disabledList: {
		type: Array,
		default() {
			return [];
		},
	},
	multiple: { type: Boolean, default: true },
	isSelOrg: { type: Boolean, default: false },
	disabledConfirm: { type: Boolean, default: true },
});
const treeRef = ref();
const idTree = ref("");
const emit = defineEmits(["cancel", "confirm"]);
const state = reactive({
	timer: null as any,
	treeLoading: false,
	searchLoading: false,
	chooseLoading: false,
	loading: false,
	inputDisabled: false,
	triggerFocus: true,
	triggerVis: false,
	searchDept: "",
	active: 1, //1部门 2职务
	deptList: [],
	deptListEmpty: true,
	defaultProps: {
		children: "departList",
		label: "departName",
	},
	jobList: [],
	jobProps: {
		children: "jobList",
		label: "jobName",
	},
	personParam: {
		statusFlag: "1", //人员是否可用 0：不可用；1可用，不填默认为全部查询
		orgVersionId: "",
		keyWord: "",
		statusCode: "",
		personProperty: "",
		departCode: "",
		departCodes: [],
		queryScope: 0, //0 默认查当前 ;1 查当前+下级组
		pageNo: 1,
		pageSize: 10000,
		isSelOrg: true
	},
	personList: [] as any,
	searchList: [] as any[],
	chooseList: [] as any[],
	checked: "",
	checkedAll: false as boolean,
});
const {
	timer,
	treeLoading,
	searchLoading,
	chooseLoading,
	loading,
	inputDisabled,
	triggerFocus,
	triggerVis,
	searchDept,
	active,
	deptList,
	deptListEmpty,
	defaultProps,
	jobList,
	jobProps,
	personParam,
	personList,
	searchList,
	chooseList,
	checked,
	checkedAll,
} = toRefs(state);
const showDialog = computed(() => props.visible);
watch(showDialog, async (newQuestion: any) => {
	if (newQuestion) {
		idTree.value = "";
		// localStorage.set("tenantId", props.tenantId);
		// localStorage.set("token", props.token);
		if(props.tenantId){
			window.localStorage.setItem("saas-pd-tenantId", props.tenantId)
		}
		prepareParams(JSON.parse(JSON.stringify(props.list)), true)
		selOrganizationTreeList();
		// queryPersonJobList();
	} else {
		window.localStorage.removeItem('saas-pd-tenantId');
		state.checked = "";
		state.deptList = [];
		state.chooseList = [];
		state.personList = [];
		state.searchList = [];
		state.personParam.keyWord = "";
		state.searchDept = "";
		state.active = 1;
	}
});
watch(searchDept, (val) => {
	if (val == "") {
		state.deptListEmpty = state.deptList.length <= 0;
	} else {
		state.deptListEmpty = true;
	}
	treeRef.value.filter(val);
});
// 批量
function queryBaseInfoBatch(param:any, backFill: boolean = false) {
	if(backFill){
		state.chooseLoading = true;
	}else{
		confirmLoading.value = true;
	}
	userCenterApi.queryBaseInfoBatch(param).then((res:any) => {
		if(backFill){
			state.chooseLoading = false;
		}else{
			confirmLoading.value = false;
			param.isSelOrg = true;
		}
		if (res && res.msgCode == "100") {
			state.chooseList = [];
			if (props.multiDeptsFlag) {
						res.responseData.forEach((v:any) => {
							let departCodes = param.personList.filter((item:any) => v.personCode === item.personCode).map((item:any) => item.departCode).filter((departCode:string) => departCode !== undefined && departCode !== null && departCode.length);
							if (v.personDepartList && v.personDepartList.length > 0) {
								v.personDepartList.forEach((depart: any) => {
									if(departCodes.length){
										if (departCodes.includes(depart.departCode)) {
											let vData = JSON.parse(JSON.stringify(v))
											// vData.departCode = depart.departCode;
											// vData.personDepartList = [depart];
											vData = { ...vData, ...depart };
											state.chooseList.push(vData);
										}
									}else {
										if(depart.masterJobFlag == '1'){
											let vData = JSON.parse(JSON.stringify(v))
											vData = { ...vData, ...depart };
											state.chooseList.push(vData);
										}
									}
								})
							}
						});
					} else {
						state.chooseList = res.responseData;
					}
					
			state.chooseList.forEach((v) => {
				v.checked = false;
				let departNameTrans = "";
				if (props.multiDeptsFlag) {
					// 支持一人多岗显示公司/部门
					v.personDepartList.forEach((p:any, pk:number) => {
						if (p.departCode == v.departCode) {
							if (p.companyCode == p.departCode) {
								v.departNameTrans = p.departName;
							} else {
								v.departNameTrans = p.companyName + (p.companyName ? "/" : "") + p.departName;
							}
						}
					});
				} else {
					v.personDepartList.forEach((p:any, pk:number) => {
						if (p.departName) {
							if (pk != 0) {
								departNameTrans += "/";
							}
							departNameTrans += p.departName;
						}
					});
					v.departNameTrans = departNameTrans;
				}
			});
			if(!backFill){
				emit("confirm", state.chooseList);
			}
		}
	});
}
function changeTab(active: number) {
	idTree.value = "";
	treeRef.value.setCurrentKey(null);
	state.active = active;
	state.personList = [];
}
// 点击外部
function onClickOutside() {
	if (state.triggerFocus) {
		return;
	}
	state.triggerVis = false;
	// 解决选择完多选框之后输入框的文字默认选中状态
	state.inputDisabled = true;
	setTimeout(() => {
		state.inputDisabled = false;
	}, 0);
}

const defaultExpandedKeysDept = ref<any>([])
// 组织架构
function selOrganizationTreeList() {
	state.treeLoading = true;
	if (props.auth) {
		// 传了部门编码，要传keyword 0 是只查上级 1是只查下级
		userCenterApi.selAuthOrganizationTree({ versionId: "", status: "1" }).then((res: any) => {
			state.treeLoading = false;
			if (res && res.msgCode == "100") {
				state.deptList = res.responseData;
				defaultExpandedKeysDept.value = state.deptList.map((department:any) => department.id);
				state.deptListEmpty = state.deptList.length <= 0;
			}
		});
	} else {
		let departCodes:any = [];
		if (props.departCode.length > 0) {
			departCodes = props.departCode.split(",");
		}
		let queryParams = {
			deptCodes: departCodes,
			versionId: "",
			departCode: "",
			departName: "",
			keyword: departCodes.length > 0 ? "1" : "",
			date: "",
			searchTopDeptFlag: true,
		}
		if(props.tenantId){
			queryParams.tenantId = props.tenantId
		}
		// 传了部门编码，要传keyword 0 是只查上级 1是只查下级
		userCenterApi
			.selOrganizationTree(queryParams)
			.then((res: any) => {
				state.treeLoading = false;
				if (res && res.msgCode == "100") {
					state.deptList = res.responseData;
					defaultExpandedKeysDept.value = state.deptList.map((department:any) => department.id);
					state.deptListEmpty = state.deptList.length <= 0;
				}
			});
	}
}
// 查询员工
function queryPersonList(params: any, operate: any) {
	let queryParams = {...params}
	if (props.tenantId) {
		queryParams.tenantId = props.tenantId;
	}
	if (operate == "search") {
		state.searchLoading = true;
	} else {
		state.loading = true;
	}
	userCenterApi.queryPersonList(queryParams).then((res: any) => {
		if (operate == "search") {
			state.searchLoading = false;
		} else {
			state.loading = false;
		}
		if (res && res.msgCode == "100") {
			let flag = false;
			if (!props.multiple) {
				state.checked = "";
				flag = true;
			}
			if (operate == "search") {
				state.searchList = [];
				if (props.multiDeptsFlag) {
					res.responseData.list.forEach((v: any) => {
						if (v.personDepartList && v.personDepartList.length > 0) {
							v.personDepartList.forEach((depart: any) => {
								let vData: any = JSON.parse(JSON.stringify(v));
								// vData.departCode = depart.departCode;
								// vData.personDepartList = [depart];
								vData = { ...vData, ...depart }
								state.searchList.push(vData);
							});
						} else {
							v.departCode = "";
							state.searchList.push(v);
						}
					});
				} else {
					state.searchList = res.responseData.list;
				}
				state.searchList.forEach((v: any) => {
					v.checked = false;
					let departNameTrans = "";
					if (props.multiDeptsFlag) {
						// 支持一人多岗显示公司/部门
						v.personDepartList.forEach((p:any, pk:number) => {
							if (p.departCode == v.departCode) {
								if (p.companyCode == p.departCode) {
									v.departNameTrans = p.departName;
								} else {
									v.departNameTrans = p.companyName + (p.companyName ? "/" : "") + p.departName;
								}
							}
						});
					} else {
						v.personDepartList.forEach((p:any, pk:number) => {
							if (p.departName) {
								if (pk != 0) {
									departNameTrans += "/";
								}
								departNameTrans += p.departName;
							}
						});
						v.departNameTrans = departNameTrans;
					}

					if (!props.multiple && flag) {
						if (state.chooseList && state.chooseList.length > 0) {
							for (let index = 0; index < state.chooseList.length; index++) {
								const element = state.chooseList[index];
								if (element.personCode == v.personCode) {
									if (props.multiDeptsFlag) {
										if (element.departCode == v.departCode) {
											flag = false;
											state.checked = element.personCode + "#" + element.departCode + "";
										}
									} else {
										flag = false;
										state.checked = element.personCode;
									}
									break;
								}
							}
						}
					}
				});
				if (state.chooseList.length > 0) {
					state.chooseList.forEach((value) => {
						state.searchList.forEach((v: any) => {
							if (props.multiDeptsFlag) {
								if (value["personCode"] == v["personCode"] && value.departCode == v.departCode) {
									v.checked = true;
								}
							} else {
								if (value["personCode"] == v["personCode"]) {
									v.checked = true;
								}
							}
						});
					});
				}
			} else {
				state.personList=[]
				// state.personList = res.responseData.list;
				res.responseData.list.forEach((v: any) => {
					v.checked = false;
					if (props.multiDeptsFlag) {
						if (state.active == 2) {
							v.personDepartList.forEach((pv:any, pk:any) => {
								if (pv.jobCode == params.keyWord) {
									v.departCode = pv.departCode;
								}
							});
						} else {
							v.departCode = params.departCode;
							if (v.personDepartList && v.personDepartList.length > 0) {
								v.personDepartList.forEach((depart: any) => {
									if(v.departCode == depart.departCode){
										let vData: any = JSON.parse(JSON.stringify(v));
										// vData.departCode = depart.departCode;
										// vData.personDepartList = [depart];
										v = { ...vData, ...depart }
										state.personList.push(v);
									}
								});
							}else{
								v.departCode = "";
								state.personList.push(v);
							}
							//匹配出与v.personDepartList departCode相同的值
							// const matchingItem = v.personDepartList.find((dv) => dv.departCode === params.departCode);
							// if (matchingItem) {
							// 	v.personDepartList = [matchingItem];
							// }
						}
					}else{
						state.personList.push(v);
					}
					if (!props.multiple && flag) {
						if (state.chooseList && state.chooseList.length > 0) {
							for (let index = 0; index < state.chooseList.length; index++) {
								const element = state.chooseList[index];
								if (element.personCode == v.personCode) {
									if (props.multiDeptsFlag) {
										if (element.departCode == v.departCode) {
											flag = false;
											state.checked = element.personCode + "#" + element.departCode + "";
										}
									} else {
										flag = false;
										state.checked = element.personCode;
									}
									break;
								}
							}
						}
					}
					let departNameTrans = "";
					if (v.personDepartList.length > 0) {
						if (props.multiDeptsFlag) {
							// 支持一人多岗显示公司/部门
							v.personDepartList.forEach((p:any, pk:any) => {
								if (p.departCode == v.departCode) {
									if (p.companyCode == p.departCode) {
										v.departNameTrans = p.departName;
									} else {
										v.departNameTrans = p.companyName + (p.companyName ? "/" : "") + p.departName;
									}
								}
							});
						} else {
							v.personDepartList.forEach((p:any, pk:any) => {
								if (p.departName) {
									if (pk != 0) {
										departNameTrans += "/";
									}
									departNameTrans += p.departName;
								}
							});
							v.departNameTrans = departNameTrans;
						}
					}
				});
				if (state.chooseList.length > 0) {
					state.chooseList.forEach((value) => {
						state.personList.forEach((v: any) => {
							if (props.multiDeptsFlag) {
								let departCode = params.departCode;
								if (state.active == 2) {
									departCode = v.departCode;
								}
								if (value["personCode"] == v["personCode"] && value.departCode == departCode) {
									v.checked = true;
								}
							} else {
								if (value["personCode"] == v["personCode"]) {
									v.checked = true;
								}
							}
						});
					});
				}
			}
			dealCheckAll();
		}
	});
}
// 自定义防抖函数
function debounce(fn:any, delay:any) {
	//闭包
	// 如果定时器已经存在了，则需要清除
	if (state.timer) {
		clearTimeout(state.timer);
	}
	// 重新执行当前的函数
	state.timer = setTimeout(() => fn(), delay);
}
// 搜索员工
function searchPersonList() {
	debounce(() => {
		const params :any  = {
			...state.personParam,
		};
		params.pageSize = 50;
		params.queryScope = 0;
		params.departCode = "";
		params.departCodes = [];
		if (!props.auth && props.departCode) {
			params.departCodes = props.departCode.split(",");
			params.queryScope = 1;
		}
		queryPersonList(params, "search");
	}, 300);
}
// 职务
function queryPersonJobList() {
	userCenterApi.queryPersonJob({ jobName: "" }).then((res: any) => {
		if (res && res.msgCode == "100") {
			state.jobList = res.responseData.responseData;
		}
	});
}
// 点击组织架构
function handleNodeClick(data: any, operate: any) {
	if (props.auth && operate != "job") {
		if (data.authFlag == "0") {
			ElMessage({
				message: "您没有权限!",
				type: "error",
			});
			if (idTree.value == "") {
				treeRef.value.setCurrentKey(null);
			} else {
				treeRef.value.setCurrentKey(idTree.value + "");
			}
			return;
		}
	}
	const params = {
		...state.personParam,
	};
	if (operate == "job") {
		params.departCode = "";
		params.keyWord = data.jobCode;
	} else {
		idTree.value = data.id;
		params.departCode = data.departCode;
		params.keyWord = "";
	}
	params.queryScope = 0;
	// params
	queryPersonList(params, "");
}
// 过滤组织架构
function filterNode(value: any, data: any) {
	if (!value) {
		return true;
	}
	// 判断为空
	if (data.departName.indexOf(value) !== -1) {
		state.deptListEmpty = false;
	}
	return data.departName.indexOf(value) !== -1;
}
//   删除方法
function deleteMethod(item: any) {
	for (let index = 0; index < state.chooseList.length; index++) {
		const element = state.chooseList[index];
		if (props.multiDeptsFlag) {
			if (element["personCode"] == item.personCode && element.departCode == item.departCode) {
				state.chooseList.splice(index, 1);
				return;
			}
		} else if (element["personCode"] == item.personCode) {
			state.chooseList.splice(index, 1);
			return;
		}
	}
}
	// personitem回调
function personItemChange(item:any, checked:any, operate:any, index:any) {
		if (!props.multiple) {
			state.checked = checked
			personChoose(item, checked, operate);
			return
		}
		if (operate == 'search') {
			state.searchList[index].checked = checked
			
		} else {
			state.personList[index].checked = checked
		}
		personChoose(item, checked, operate);
	}
//   选中
function personChoose(item: any, checked: any, operate: any) {
	if (!props.multiple) {
		state.chooseList = [];
		state.chooseList.push(item);
		return;
	}
	if (checked) {
		state.chooseList.push(item);
	} else {
		deleteMethod(item);
	}
	if (operate == "search") {
		dealPersonListMethod(item, checked);
	} else {
		dealSearchListMethod(item, checked);
	}
	dealCheckAll();
}
// 处理全选框
function dealCheckAll() {
	// 判断全选是否勾选上
	if (props.multiple) {
		//判断state.personList是不是都是true,如果是true state.checkedAll为true
		if (state.personList.every((v: any) => v.checked)) {
			state.checkedAll = true;
		} else {
			state.checkedAll = false;
		}
	}
}
// 如果删除选中personList也要改变
function dealPersonListMethod(item: any, checked: any) {
	for (let index = 0; index < state.personList.length; index++) {
		const element: any = state.personList[index];
		if (props.multiDeptsFlag) {
			if (element["personCode"] == item.personCode && element.departCode == item.departCode) {
				element.checked = checked;
				return;
			}
		} else if (element["personCode"] == item.personCode) {
			element.checked = checked;
			return;
		}
	}
}
// 如果删除选中searchList也要改变
function dealSearchListMethod(item: any, checked: any) {
	for (let index = 0; index < state.searchList.length; index++) {
		const element: any = state.searchList[index];
		if (props.multiDeptsFlag) {
			if (element["personCode"] == item.personCode && element.departCode == item.departCode) {
				element.checked = checked;
				return;
			}
		} else if (element["personCode"] == item.personCode) {
			element.checked = checked;
			return;
		}
	}
}
// 删除按钮删除选中
function deleteChoose(item: any) {
	deleteMethod(item);
	dealPersonListMethod(item, false);
	if (props.multiple) {
		dealCheckAll();
	} else {
		state.checked = "";
	}
	dealSearchListMethod(item, false);
}
//清空
function clearChoose() {
	if (state.chooseList.length == 0) {
		return;
	}
	state.chooseList = [];

	if (props.multiple) {
		state.checkedAll = false;
		state.searchList.forEach((v: any) => {
			v.checked = false;
		});
		state.personList.forEach((v: any) => {
			v.checked = false;
		});
	} else {
		state.checked = "";
	}
}
//   全选置灰-遇到置灰情况时候
function disabledCheckAll() {
	if (props.disabledList.length == 0) {
		return false;
	}
	for (let i = 0; i < state.personList.length; i++) {
		if (props.disabledList.includes(props.multiDeptsFlag ? state.personList[i]["personCode"] + "#" + state.personList[i]["departCode"] : state.personList[i]["personCode"])) {
			return true;
		}
	}
	return false;
}
// 全选
function chooseAll() {
	if (state.checkedAll) {
		state.personList.forEach((v: any) => {
			if (!v.checked) {
				v.checked = true;
				personChoose(v, true, "");
			}
		});
	} else {
		state.personList.forEach((v: any) => {
			if (v.checked) {
				v.checked = false;
				personChoose(v, false, "");
			}
		});
	}
}
const prepareParams =(list:any, backFill:boolean = false)=>{
	if (list.length > 0) {
			let param :any = { personList: [] };
			if (props.multiple) {
				param.personList = list.map((v:any) => ({ personCode: v.personCode, departCode: props.multiDeptsFlag ? v.departCode || "" : "" }));
			} else {
				let firstItem = list[0];
				param.personList.push({
					personCode: firstItem.personCode,
					departCode: props.multiDeptsFlag ? firstItem.departCode || "" : "",
				});
				state.checked = props.multiDeptsFlag ? `${list[0].personCode}#${list[0].departCode || ""}` : list[0].personCode;
			}
			queryBaseInfoBatch(param, backFill);
		}
}
const confirmLoading = ref(false);
// 确定
function handleConfirm() {	
	if(props.isSelOrg){
		prepareParams(JSON.parse(JSON.stringify(state.chooseList)))
	}else{
		emit("confirm", state.chooseList);
	}
		
	
}
// 取消
function handleClose() {
	emit("cancel");
}
</script>